/** Viewport size types */
export var ESizeTypes;
(function (ESizeTypes) {
    ESizeTypes["Desktop"] = "desktop";
    ESizeTypes["Tablet"] = "tablet";
    ESizeTypes["Phone"] = "phone";
})(ESizeTypes || (ESizeTypes = {}));
/** Orientation types */
export var EOrientationTypes;
(function (EOrientationTypes) {
    EOrientationTypes["Landscape"] = "landscape";
    EOrientationTypes["Portrait"] = "portrait";
})(EOrientationTypes || (EOrientationTypes = {}));
//# sourceMappingURL=types.js.map